import { makeAutoObservable } from "mobx";

interface Credentials {
  username: string;
  password: string;
}

class AuthStore {
  private credentials: Credentials;
  constructor() {
    this.credentials = {
      username: "",
      password: "",
    };
    makeAutoObservable(this);
  }

  public setCredentials(credentials: Credentials): void {
    this.credentials = credentials;
  }

  public getCredentials(): Credentials {
    return this.credentials;
  }
}

const authStore = new AuthStore();

export { authStore };
